(() => {
 const config=window.VeloraShop;
 if(!config)return;
 const escapeHtml=value=>String(value||'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
 const root=config.root;
 const policyLink=(url,label)=>url?`<p><a class="link-arrow" href="${escapeHtml(url)}">${label} →</a></p>`:'';
 modalContent.account=['Mon compte',`<p>Retrouvez votre compte et vos commandes sur la boutique.</p><a class="cta" href="${escapeHtml(config.accountUrl)}">Accéder à mon compte</a>`];
 modalContent.tracking=['Suivre ma commande',`<p>Le lien de suivi figure dans votre e-mail d’expédition. Vous pouvez également retrouver vos commandes depuis votre compte.</p><a class="cta" href="${escapeHtml(config.accountUrl)}">Mes commandes</a>`];
 modalContent.contact=['Nous contacter',`<p>Retrouvez notre formulaire et les coordonnées du service client.</p><a class="cta" href="${root}pages/contact">Contacter Velora</a>`];
 modalContent.delivery=['Livraison & retours',policyLink(config.policies.delivery,'Politique de livraison')+policyLink(config.policies.returns,'Politique de retour')||'<p>Les modalités de livraison et de retour sont en cours de préparation.</p>'];
 modalContent.legal=['Informations légales',policyLink(config.policies.legal,'Consulter les mentions légales')||'<p>Les mentions légales sont en cours de préparation.</p>'];
 modalContent.privacy=['Confidentialité',policyLink(config.policies.privacy,'Politique de confidentialité')||'<p>La politique de confidentialité est en cours de préparation.</p>'];
 modalContent.preview=['Aperçu Shopify', '<p>Le thème Velora est installé en brouillon. Les achats sont désactivés pendant la préparation du catalogue.</p><p>Les trois lots, leurs tailles, leurs teintes et leurs cadeaux sont enregistrés dans le configurateur. Le produit, les mensurations et les conditions de livraison doivent être validés avant la mise en vente.</p>'];
 const badge=document.querySelector('.preview-badge');
 if(badge)badge.hidden=!config.preview;
 const note=document.querySelector('.cart-demo');
 if(note)note.textContent=config.preview?'Aperçu Shopify · Commandes désactivées.':'Paiement sécurisé par Shopify';
 async function request(path,data){
  const response=await fetch(root+path,{method:data?'POST':'GET',credentials:'same-origin',headers:data?{'Content-Type':'application/json'}:{},body:data?JSON.stringify(data):undefined});
  const result=await response.json();
  if(!response.ok)throw new Error(result.description||result.message||'Impossible de mettre à jour le panier. Réessayez.');
  return result;
 }
 const selectionKey=c=>c.pack+':'+c.items.map(i=>i.shade+'/'+i.size).join('|');
 const propsFor=c=>{
  const props={_velora_bundle:c.pack,_velora_key:selectionKey(c),_velora_selection:JSON.stringify(c.items)};
  c.items.forEach((item,i)=>props['Collant '+(i+1)]=item.shade+' · '+item.size);
  if(c.pack==='trio')props['Cadeau inclus']='1 paire de jambières';
  if(c.pack==='winter')props['Cadeaux inclus']='1 paire de jambières + 1 collant floral';
  return props;
 };
 document.querySelector('#checkout').onclick=async()=>{
  if(config.preview||!config.productAvailable){
   document.querySelector('#modal-content').innerHTML='<span class="eyebrow">APERÇU SHOPIFY</span><h2 id="modal-title">La boutique se prépare.</h2><p>Votre sélection est enregistrée. Les commandes seront ouvertes après la validation et l’activation du produit sur Shopify.</p>';
   document.querySelector('#modal').showModal();return;
  }
  if(!cartItems.length)return;
  const button=document.querySelector('#checkout');button.disabled=true;
  document.querySelector('#cart-feedback').textContent='Préparation de votre paiement sécurisé…';
  try{
   const product=await request('products/'+config.productHandle+'.js');
   for(const c of cartItems){
    const variant=product.variants.find(v=>v.id===config.variants[c.pack]);
    if(!variant||!variant.available)throw new Error('Ce lot n’est pas disponible actuellement.');
    if(variant.price!==cents(c.pack))throw new Error('Le tarif de ce lot a changé. Rechargez la page avant de poursuivre.');
   }
   const existing=await request('cart.js');
   const desired=new Map();
   for(const c of cartItems){const key=selectionKey(c);const prior=desired.get(key);if(prior)prior.quantity+=c.quantity;else desired.set(key,{id:config.variants[c.pack],quantity:c.quantity,properties:propsFor(c)});}
   const updates={},newItems=[];
   for(const line of existing.items){
    if(!line.properties?._velora_key)continue;
    const want=desired.get(line.properties._velora_key);
    updates[line.key]=want?want.quantity:0;
    if(want)desired.delete(line.properties._velora_key);
   }
   for(const want of desired.values())newItems.push(want);
   if(newItems.length)await request('cart/add.js',{items:newItems});
   if(Object.keys(updates).length)await request('cart/update.js',{updates});
   const confirmed=await request('cart.js');
   const requestedQuantity=cartItems.reduce((n,c)=>n+c.quantity,0);
   const actualQuantity=confirmed.items.filter(i=>i.properties?._velora_key).reduce((n,i)=>n+i.quantity,0);
   if(requestedQuantity!==actualQuantity)throw new Error('Vérifiez votre panier avant de poursuivre.');
   window.location.assign(root+'checkout');
  }catch(error){document.querySelector('#cart-feedback').textContent=error.message;button.disabled=false;}
 };
})();
